import queryString from 'query-string';
import http from '.';
import { apiCourseRegistration } from './apiRouter';

const getCourseRegistration = (body, axiosConfig = {}) => {
  const params = queryString.stringify(body);
  return http.get(`${apiCourseRegistration}?${params}`, axiosConfig);
};

const getCourseRegistrationById = () => {
  return http.get(`${apiCourseRegistration}/course-schedules`);
};

const updateCourseRegistration = (id, body) => {
  return http.put(`${apiCourseRegistration}/${id}`, body);
};

const getInfo = (id) => {
  return http.get(`${apiCourseRegistration}/${id}`);
};

const changeStatus = (id, body) => {
  return http.put(`${apiCourseRegistration}/${id}/status`, body);
};

const getInfoUser = (body) => {
  const params = queryString.stringify(body);
  return http.get(`${apiCourseRegistration}/users?${params}`);
};

const getCourseSchedules = (id) => {
  return http.get(`${apiCourseRegistration}/course-schedules?course=${id}`);
};

const addUserInCourse = ({ eventId, form }) => {
  return http.post(`${apiCourseRegistration}/${eventId}/add-user`, form);
};

const changeStatusRetake = (courseId, body) => {
  return http.put(`${apiCourseRegistration}/${courseId}/status`, body);
};

const CourseScheduleRegistationServices = {
  getCourseRegistration,
  getCourseRegistrationById,
  updateCourseRegistration,
  getInfo,
  changeStatus,
  getInfoUser,
  getCourseSchedules,
  addUserInCourse,
  changeStatusRetake,
};

export default CourseScheduleRegistationServices;
